import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import I from "../../_mixins/use-config.js";
import S from "../../_mixins/use-form-item.js";
import N from "../../../../../../vooks@0.2.12_vue@3.5.18/node_modules/vooks/es/use-merged-state.js";
import { createInjectionKey as U } from "../../_utils/vue/create-injection-key.js";
import { warnOnce as k } from "../../_utils/naive/warn.js";
import { call as n } from "../../_utils/vue/call.js";
import { defineComponent as w, watchEffect as x, computed as s, provide as G, h as P } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as E, toRef as v } from "../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
const _ = U("n-checkbox-group"), j = {
  min: Number,
  max: Number,
  size: String,
  value: Array,
  defaultValue: {
    type: Array,
    default: null
  },
  disabled: {
    type: Boolean,
    default: void 0
  },
  "onUpdate:value": [Function, Array],
  onUpdateValue: [Function, Array],
  // deprecated
  onChange: [Function, Array]
}, H = w({
  name: "CheckboxGroup",
  props: j,
  setup(t) {
    process.env.NODE_ENV !== "production" && x(() => {
      t.onChange !== void 0 && k("checkbox-group", "`on-change` is deprecated, please use `on-update:value` instead.");
    });
    const {
      mergedClsPrefixRef: g
    } = I(t), p = S(t), {
      mergedSizeRef: y,
      mergedDisabledRef: h
    } = p, f = E(t.defaultValue), C = s(() => t.value), l = N(C, f), R = s(() => {
      var u;
      return ((u = l.value) === null || u === void 0 ? void 0 : u.length) || 0;
    }), A = s(() => Array.isArray(l.value) ? new Set(l.value) : /* @__PURE__ */ new Set());
    function T(u, e) {
      const {
        nTriggerFormInput: c,
        nTriggerFormChange: d
      } = p, {
        onChange: o,
        "onUpdate:value": i,
        onUpdateValue: a
      } = t;
      if (Array.isArray(l.value)) {
        const r = Array.from(l.value), m = r.findIndex((F) => F === e);
        u ? ~m || (r.push(e), a && n(a, r, {
          actionType: "check",
          value: e
        }), i && n(i, r, {
          actionType: "check",
          value: e
        }), c(), d(), f.value = r, o && n(o, r)) : ~m && (r.splice(m, 1), a && n(a, r, {
          actionType: "uncheck",
          value: e
        }), i && n(i, r, {
          actionType: "uncheck",
          value: e
        }), o && n(o, r), f.value = r, c(), d());
      } else
        u ? (a && n(a, [e], {
          actionType: "check",
          value: e
        }), i && n(i, [e], {
          actionType: "check",
          value: e
        }), o && n(o, [e]), f.value = [e], c(), d()) : (a && n(a, [], {
          actionType: "uncheck",
          value: e
        }), i && n(i, [], {
          actionType: "uncheck",
          value: e
        }), o && n(o, []), f.value = [], c(), d());
    }
    return G(_, {
      checkedCountRef: R,
      maxRef: v(t, "max"),
      minRef: v(t, "min"),
      valueSetRef: A,
      disabledRef: h,
      mergedSizeRef: y,
      toggleCheckbox: T
    }), {
      mergedClsPrefix: g
    };
  },
  render() {
    return P("div", {
      class: `${this.mergedClsPrefix}-checkbox-group`,
      role: "group"
    }, this.$slots);
  }
});
export {
  _ as checkboxGroupInjectionKey,
  j as checkboxGroupProps,
  H as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/checkbox/src/CheckboxGroup.js
// module id = 265
// module chunks = 67